export enum LocalStorageKeys {
  user_authenticated = 'user_authenticated',
  user_access_token = 'user_access_token',
  originalRequestURL = 'originalRequestURL',
  user_acknowledged = 'user_acknowledged',
}
export enum AuthenticationStatus {
  Authenticated = 'Authenticated',
  NotAuthenticated = 'NotAuthenticated',
}
export enum AcknowledgedStatus {
  Acknowledged = 'Acknowledged',
  NotAcknowledged = 'NotAcknowledged',
}

export const guardianLink = window._env_.GUARDIAN_APP_ID;

export const authenticationMessages = {
  redirecting: 'Redirecting',
  sessionUpdating: 'Session Updating',
  signingIn: 'Signing In',
  signingOut: 'Signing Out',
  validating: 'Validating',
  notAuthorized:
    'You do not have access to this site or page. If you feel you have reached this page in error, please contact a system administrator.',
  error:
    'Oops! Something went wrong. If this issue persists, please contact a system administrator.',
  loggedOut:
    'You are currently logged out. If you feel you have reached this page in error, please contact a system administrator.',
};

// Permissions
export const pagePermissionsNames = {
  appeal: 'APPEAL',
  claim: 'CLAIM',
  claim_action: 'CLAIM ACTION',
  document: 'DOCUMENT',
  inquiry: 'INQUIRY',
  inquiry_action: 'INQUIRY ACTION',
  help_and_support: 'HELP AND SUPPORT',
  rule_spec: 'RULE SPEC'
};

export const PERMISSIONS_GRID_COLUMNS = new Set([
  {
    dataName: 'role',
    text: 'Role',
    sortable: true,
    isSorted: 0,
    width: '280px',
  },
  {
    dataName: 'name',
    text: 'Permission Name',
    sortable: true,
    isSorted: 0,
    width: '500px',
  },
  {
    dataName: 'create',
    text: 'Create',
    sortable: true,
    isSorted: 0,
    width: '120px;',
  },
  {
    dataName: 'read',
    text: 'Read',
    sortable: true,
    isSorted: 0,
    width: '120px;',
  },
  {
    dataName: 'edit',
    text: 'Edit',
    sortable: true,
    isSorted: 0,
    width: '120px;',
  },
  {
    dataName: 'delete',
    text: 'Delete',
    sortable: true,
    isSorted: 0,
    width: '140px;',
  },
]);
